
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { AdminSubscription } from "./types";
import { formatPrice, formatDate, getStatusColor } from "./utils";
import { Loader2 } from "lucide-react";

interface SubscriptionsTableProps {
  subscriptions: AdminSubscription[];
  loading: boolean;
  searchQuery: string;
}

export function SubscriptionsTable({ subscriptions, loading, searchQuery }: SubscriptionsTableProps) {
  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
      </div>
    );
  }

  return (
    <div className="min-h-[200px]">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>School</TableHead>
            <TableHead>Product</TableHead>
            <TableHead>Plan</TableHead>
            <TableHead>Price</TableHead>
            <TableHead>Start Date</TableHead>
            <TableHead>End Date</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {subscriptions.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="text-center">
                {searchQuery ? "No matching subscriptions found" : "No subscriptions found"}
              </TableCell>
            </TableRow>
          ) : (
            subscriptions.map((subscription) => (
              <TableRow key={subscription.id}>
                <TableCell>
                  <div className="flex flex-col">
                    <span>{subscription.school_name}</span>
                    <span className="text-xs text-gray-500">ID: {subscription.school_id || "N/A"}</span>
                  </div>
                </TableCell>
                <TableCell>{subscription.product_name}</TableCell>
                <TableCell>{subscription.plan_name}</TableCell>
                <TableCell>{formatPrice(subscription.plan_price)}</TableCell>
                <TableCell>{formatDate(subscription.start_date)}</TableCell>
                <TableCell>
                  {subscription.end_date ? formatDate(subscription.end_date) : '-'}
                </TableCell>
                <TableCell>
                  <Badge className={getStatusColor(subscription.status)}>
                    {subscription.status.toUpperCase()}
                  </Badge>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
